const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedP2pMarket: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const p2pmarkets = (state = initialState, action) => {
	switch (action.type) {
		case 'P2PMARKET_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'P2PMARKET_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'P2PMARKET_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'P2PMARKET_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'P2PMARKET_GET_CURRENT':
			return {
				...state,
				selectedP2pMarket: action.selectedP2pMarket,
			}
		case 'P2PMARKET_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default p2pmarkets
